// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  cursor: pointer !important;
}

.Attachments-ht {
  max-height: 100px;
  overflow: auto;
}

.editorcorrecs > .tox-tinymce {
  height: calc(100vh - 23rem) !important;
}

.tox-tinymce {
  height: 450px !important;
}

::ng-deep p-autocomplete span.p-autocomplete {
  width: 100%;
  height: calc(1.3em + 0.75rem + 0px);
  border-radius: 3px;
  background-color: #ffffff;
  margin-bottom: 0.15rem;
  font-size: 11px;
  color: #464646;
  line-height: 18px;
  -webkit-appearance: auto;
  appearance: auto;
}

::ng-deep p-autocomplete .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item {
  padding: 0 !important;
  font-size: 13px;
}

::ng-deep p-autocomplete .p-autocomplete-panel .p-autocomplete-items {
  padding: 0 !important;
  font-size: 13px;
}

::ng-deep p-autocomplete:focus,
::ng-deep p-autocomplete:focus-within {
  box-shadow: 0 0 0 0.02rem rgb(76, 106, 130) !important;
  border-color: #89a8c1 !important;
}

::ng-deep ul.p-autocomplete-multiple-container.p-component.p-inputtext {
  overflow-y: auto;
}

.composeEditor .tox-tinymce {
  height: 200px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/ist/ist-application-ext/ist-milestones/milestone-send-notification/milestone-send-notification.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,sCAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,WAAA;EACA,mCAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,eAAA;AACF;;AACA;EACE,qBAAA;EAAsB,eAAA;AAGxB;;AADA;;EAEE,sDAAA;EACE,gCAAA;AAIJ;;AADA;EACE,gBAAA;AAIF;;AAFA;EACE,wBAAA;AAKF","sourcesContent":["a {\r\n  cursor: pointer !important;\r\n}\r\n\r\n.Attachments-ht {\r\n  max-height: 100px;\r\n  overflow: auto;\r\n}\r\n\r\n.editorcorrecs > .tox-tinymce {\r\n  height: calc(100vh - 23rem) !important;\r\n}\r\n\r\n.tox-tinymce {\r\n  height: 450px !important;\r\n}\r\n\r\n::ng-deep p-autocomplete span.p-autocomplete {\r\n  width: 100%;\r\n  height: calc(1.3em + 0.75rem + 0px);\r\n  border-radius: 3px;\r\n  background-color: #ffffff;\r\n  margin-bottom: 0.15rem;\r\n  font-size: 11px;\r\n  color: #464646;\r\n  line-height: 18px;\r\n  -webkit-appearance: auto;\r\n  appearance: auto;\r\n}\r\n\r\n::ng-deep p-autocomplete .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item{\r\n  padding: 0 !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep p-autocomplete .p-autocomplete-panel .p-autocomplete-items{\r\n  padding: 0 !important;font-size: 13px;\r\n}\r\n::ng-deep p-autocomplete:focus,\r\n::ng-deep p-autocomplete:focus-within{\r\n  box-shadow: 0 0 0 0.02rem rgb(76 106 130) !important;\r\n    border-color: #89a8c1 !important;\r\n}\r\n\r\n::ng-deep ul.p-autocomplete-multiple-container.p-component.p-inputtext{\r\n  overflow-y: auto;\r\n}\r\n.composeEditor .tox-tinymce{\r\n  height: 200px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
